import * as types from '../action/types';

const initialState = null;

const selectedBranch = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_SELECTED_BRANCH:
            return action.payload;
        case types.CLEAR_SELECTED_BRANCH:
            return null;
        default:
            return state;
    }
};

export default selectedBranch;